document.addEventListener('DOMContentLoaded', function() {

    // For popup open script
    
    const langPopupBtn = document.querySelectorAll('.lang-popup-btn');
    const langPopup = document.querySelector('.cl-popup--drawer');
    const overlay = document.querySelector('.cl-popup--drawer-overlay');
    langPopupBtn.forEach(langBtn => {
        langBtn.addEventListener('click', function(){
            langPopup.classList.add('active');
            overlay.classList.add('active');
            document.querySelector('body').style.overflow = 'hidden';
        });
    });

    // For popup close script

    const closePopup = document.querySelectorAll('.cl-popup--close, .cl-popup--drawer-overlay');
    closePopup.forEach(closeBtn => {
        closeBtn.addEventListener('click', function() {
            langPopup.classList.remove('active');
            overlay.classList.remove('active');
            document.querySelector('body').style.overflow = '';
        });
    });
    
    // Popup langauge Script

    if(!window.continentListenerAdded){
        window.continentListenerAdded = true;

        let localizationData = {};
        fetch(window.localizationJsonUrl)
        .then(res => res.json())
        .then(data => {
            localizationData = data;        
        });

        const continent = document.querySelector('select#cl-continent');
        const countryDropdown = document.querySelector('select#cl-country');
        const langDropdown = document.querySelector('select#cl-language');
        const submitBtn = document.querySelector('#cl-localization--form').querySelector('button[type="submit"]');
        
        continent.addEventListener('change', function() {
            const selectedContinent = this.value;
            
            countryDropdown.innerHTML = '';
            langDropdown.innerHTML = '';
            
            if(localizationData[selectedContinent]){
                const countries = Object.keys(localizationData[selectedContinent]);
                countries.forEach(country => {
                    const option = document.createElement('option');
                    option.value = country;
                    option.textContent = country;
                    countryDropdown.appendChild(option);
                });

                const languages = localizationData[selectedContinent][countries[0]].languages;
                languages.forEach(lang =>{
                    const option = document.createElement('option');
                    option.value = lang;
                    option.textContent = lang;
                    langDropdown.appendChild(option);
                });
                
                const urlsObj = localizationData[selectedContinent][countries[0]].urls;
                const firstUrl = Object.values(urlsObj)[0];
                if(firstUrl){
                    submitBtn.classList.add('active');
                    document.querySelector('#cl-localization--form').addEventListener('submit', function(e) {
                        e.preventDefault();
                        window.location.href = firstUrl;
                    });
                }
            }
        });
        countryDropdown.addEventListener('change', function() {
            const selectedContinent = continent.value;
            const selectedCountry = this.value;
            const languages = localizationData[selectedContinent][selectedCountry].languages;        
            langDropdown.innerHTML = '';

            languages.forEach(lang => {
                const option = document.createElement('option');
                option.value = lang;
                option.textContent = lang;
                langDropdown.appendChild(option);
            });            
            
            const urlsObj = localizationData[selectedContinent][selectedCountry].urls;
            const firstUrl = Object.values(urlsObj)[0];
          
            if(firstUrl){
                submitBtn.classList.add('active');
                document.querySelector('#cl-localization--form').addEventListener('submit', function(e) {
                    e.preventDefault();
                    window.location.href = firstUrl;
                });
            }
        });
        langDropdown.addEventListener('change', function() {
            const selectedContinent = continent.value;
            const selectedCountry = countryDropdown.value;
            const selectedLang = this.value;
            const mainUrl = localizationData[selectedContinent][selectedCountry].urls[selectedLang];
            if(mainUrl){
                submitBtn.classList.add('active');
                document.querySelector('#cl-localization--form').addEventListener('submit', function(e) {
                    e.preventDefault();
                    window.location.href = mainUrl;
                });
            }
        });
    }
});